module.exports = __webpack_public_path__ + "img/user.f31e2806.png";